import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { PassengerAPI } from "../../../../../../API/PassengerAPIs/PassengerAPIs";
import ApiResponseHandler from "../../../../../../STCLibrary/ApiResponseHandler/ApiResponseHandler";
import NotificationContext from "../../../../../../STCLibrary/NotificationSystem/NotificationContext";
import STC from "../../../../../../STCLibrary/STCFactory/STCFactory";
import { format } from "date-fns";

export default function PaymentAttempts(){

    const ColumnHeaders = [
        'Date',
        'Booking ID', 
        'Order ID',
        'Currency',
        'Amount',
        'Status',
    ]

    const routeParams = useParams();
    const navigate = useNavigate()
    const notificationCtx = useContext(NotificationContext);

    const [loading, setLoading] = useState(true);
    const [loadingFailed, setLoadingFailed] = useState(false);
    const [attempts, setAttempts] = useState([]);

    const getPaymentAttempts = () => {
        PassengerAPI.GetPassengerPaymentAttempts(routeParams.userID)
        .then((response) => {
            if(response.status === 200){
                console.log(response.data)
                setAttempts(response.data);
                setLoading(false);
            }
        })
        .catch((err) => {
            ApiResponseHandler(err.response, notificationCtx, navigate);
            console.log(err);
        })
    } 

    const thData = () => {
        return ColumnHeaders.map((header, index) => {
            return(
                <th key={index}>{header}</th>
            )
        })
    }

    const isToday = (date) => {
        const today = new Date();

        return (
            date.getFullYear() === today.getFullYear() &&
            date.getMonth() === today.getMonth() &&
            date.getDate() === today.getDate()
        );
    }

    const displayStatus = (attempt) => {
        if(isToday(new Date(attempt.transactionAttemptedTime)) && attempt.transactionStatus === 'CANCELLED'){
            return 'PENDING'
        }
        else{
            return attempt.transactionStatus
        }
    } 

    const tdData = () => {
        return attempts.map((attempt) => {
            return(
                <tr key={attempt.id}>
                    <td>{format(new Date(attempt.transactionAttemptedTime), 'hh:mm dd/MM/yyyy')}</td>
                    <td>{attempt.bookingId}</td>
                    <td>{attempt.paymentOrderId}</td>
                    <td>{attempt.currency}</td>
                    <td>{attempt.transactionAmount}</td>
                    <td>{displayStatus(attempt)}</td>
                </tr>
            )
        })
    }

    useEffect(() => {
        getPaymentAttempts();
    }, [])

    if(loading){
        return(
            <div>
                <h4>Attempted Payments</h4>
                <div>Loading...</div>
            </div>
        )
    }
    else{
        return(
            <div>
                <h4>Attempted Payments</h4>
                {(attempts.find((attempt) => isToday(new Date(attempt.transactionAttemptedTime)) && attempt.transactionStatus === 'CANCELLED')) &&<STC.Alert className='m-1' variant='warning'>PENDING payments will update the following working day.</STC.Alert>}
                {loadingFailed ? 
                <div>Failed to load. Please try again later.</div> 
                : 
                <div>
                   {attempts.length > 0 ? 
                    <STC.Table hover striped responsive>
                        <thead>
                            <tr>{thData()}</tr>
                        </thead>
                        <tbody>{tdData()}</tbody>
                    </STC.Table>
                    : 
                    <div>Nothing to show here.</div>
                    }
                
                 
                </div>
                }
            </div>
        )
    }
}